import { MLSID } from '@utils/pageBuilderHelper';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadAgenda from './components/DownloadAgenda';
import DownloadAttendeeList from './components/DownloadAttendeeList';
import DownloadPartnerProspectus from './components/DownloadPartnerProspectus';
import DownloadWhitePaper from './components/DownloadWhitePaper';
import MediaPackageDownload from './components/MediaPackageDownload';
import PodcastContent from './components/PodcastContent';
import SaveTheDate from './components/SaveTheDate';
import StartSurvey from './components/StartSurvey';
import VideoContent from './components/VideoContent';
import WebappFreeTicketOnsite from './components/WebappFreeTicketOnsite';

interface BooleanValue {
  required: boolean;
  visible: boolean;
}
export type DefaultBooleanValues = Record<string, BooleanValue>;

interface InboundButtonProps {
  buttonType: string;
  inboundValues: {
    nonBooleanValues: Record<string, string>;
    booleanValues: DefaultBooleanValues;
  };
}

const InboundButton = ({ buttonType, inboundValues }: InboundButtonProps) => {
  const { t } = useTranslation();

  const buttonComponent = useMemo(() => {
    switch (buttonType) {
      case MLSID.AGENDA_DOWNLOAD:
        return (
          <DownloadAgenda
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.ATTENDEE_LIST_DOWNLOAD:
        return (
          <DownloadAttendeeList
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.PARTNER_PROSPECTUS_DOWNLOAD:
        return (
          <DownloadPartnerProspectus
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.WHITE_PAPER_DOWNLOAD:
        return (
          <DownloadWhitePaper
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.SAVE_THE_DATE:
        return (
          <SaveTheDate
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
          />
        );
      case MLSID.VIDEO_CONTENT:
        return (
          <VideoContent
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.PODCAST_CONTENT:
        return (
          <PodcastContent
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.START_SURVEY:
        return (
          <StartSurvey
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.MEDIA_PACKAGE_DOWNLOAD:
        return (
          <MediaPackageDownload
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      case MLSID.WEBAPP_FREETICKET_ONSITE:
        return (
          <WebappFreeTicketOnsite
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
            inboundValues={inboundValues}
          />
        );
      default:
        return (
          <DownloadAgenda
            label={t(`inbound-button.${buttonType}`)}
            buttonType={buttonType}
          />
        );
    }
  }, [buttonType, inboundValues, t]);

  return buttonComponent;
};

export default InboundButton;
